import { useCallback } from "react"
import { useAppContext } from "@app/providers/app"
import { useAnalytics } from "@app/hooks/useAnalytics"

export const useShopifyProduct = () => {
  const { activeProduct, setActiveProduct } = useAppContext()
  const { trackProductView } = useAnalytics()

  const selectProduct = useCallback(
    (product, path) => {
      if (path?.includes("products") && product) {
        let currentProduct = product

        try {
          currentProduct = product?.shopify?.raw ? JSON.parse(product?.shopify?.raw) : product
        } catch (e) {
          console.error((e as Error).message)
        }

        if (!activeProduct || activeProduct.id !== currentProduct.id) {
          setActiveProduct(currentProduct)
          // RE-56718: previously guarded by `cartId && customer?.id`, which
          // meant guests never fired dl_view_item. Analytics tracking should
          // not depend on auth state — drop the guard.
          setTimeout(() => {
            trackProductView(currentProduct, currentProduct.variants[0], false)
          }, 400)
        }
      } else {
        if (activeProduct !== false) setActiveProduct(false)
      }
    },
    [activeProduct, setActiveProduct, trackProductView]
  )

  return { activeProduct, selectProduct }
}
